import { render, staticRenderFns } from "./fortuneList.vue?vue&type=template&id=233756ce&scoped=true&"
import script from "./fortuneList.vue?vue&type=script&lang=js&"
export * from "./fortuneList.vue?vue&type=script&lang=js&"
import style0 from "./fortuneList.vue?vue&type=style&index=0&id=233756ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233756ce",
  null
  
)

export default component.exports